<mat-expansion-panel [expanded]="panelOpenState"
                     [disabled]="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="exp">
        <i class="far fa-chevron-up"
           (click)="togglePanel()"
           *ngIf="isHidden"></i>
        <i class="far fa-chevron-down"
           (click)="togglePanel()"
           *ngIf="!isHidden"></i>
      </div>
      <div class="project-header"
           (click)="togglePanel()">
        {{ currentEstimate?.projectCode }} &#8901;
        {{ currentEstimate?.projectName }}
      </div>
      <div class="rev-menu-btn"
           [matMenuTriggerFor]="revisionMenu"
           #revisionTrigger="matMenuTrigger"
           (click)="revisionTrigger.openMenu()">
        <span translate="EXPANSION_PANEL.REVISION"
              [translateParams]="{number: currentEstimate.revision}"></span>
        <i class="far fa-chevron-down"></i>
      </div>
      <mat-menu disableRipple="true"
                #revisionMenu="matMenu"
                xPosition="after">
        <div *ngIf="!isGroupApproved && currentEstimate.status !== 'Imported'"
             (click)="addNewRevision()"
             mat-menu-item
             class="new-rev">
          <div>
            <i class="fas fa-plus"></i>
            {{ "BUTTON.NEW_REV" | translate }}
          </div>
        </div>
        <a href="#"
           *ngFor="let estimateRevisionVM of estimateRevisionVMs"
           [routerLink]="['/app/estimate-detail', estimateRevisionVM.estimateId]"
           mat-menu-item>{{ estimateRevisionVM.revision }}</a>
      </mat-menu>
      <pop-status-chip [status]="currentEstimate?.status"></pop-status-chip>
    </mat-panel-title>

    <pop-user-card></pop-user-card>
  </mat-expansion-panel-header>
  <form #estimateSummaryForm="ngForm">
    <div class="header-row">
      <div class="col-row">
        <div>
          <label for="codeRef"
                 translate="HEADER.REF"></label>
          <input type="text"
                 disabled="disabled"
                 [value]="currentEstimate?.codeRef"
                 name="codeRef" />
        </div>
        <div>
          <label for="projectModelCode"
                 translate="HEADER.MODEL"></label>
          <input type="text"
                 disabled="disabled"
                 [value]="currentEstimate?.projectModelCode"
                 name="projectModelCode" />
        </div>
      </div>
      <div class="col-row">
        <div>
          <label for="budgetType"
                 translate="TOOLBAR.BUDGET"></label>
          <input type="text"
                 disabled="disabled"
                 [value]="currentEstimate?.budgetType | enumLabel: 'BUDGET_TYPE' | translate"
                 name="budgetType" />
        </div>
        <div>
          <label for="projectManagerId"
                 translate="HEADER.PROJECT_LEAD"></label>
          <input type="text"
                 disabled="disabled"
                 [value]="currentEstimate?.projectManager?.name"
                 name="projectManagerId" />
        </div>
      </div>
      <div class="col-row">
        <div>
          <label for="client"
                 translate="HEADER.CLIENT"></label>
          <input type="text"
                 disabled="disabled"
                 [value]="currentEstimate?.clientName"
                 name="client" />
        </div>
        <div>
          <label for="department"
                 translate="HEADER.CLIENT_CONTACT"></label>
          <input type="text"
                 disabled="disabled"
                 [value]="currentEstimate?.clientContactName"
                 name="department" />
        </div>
      </div>
      <div class="col-row">
        <div>
          <label for="rate"
                 translate="HEADER.ESTIMATE_TYPE"></label>
          <input type="text"
                 disabled="disabled"
                 [value]="currentEstimate?.estimateType | enumLabel: 'ESTIMATE_TYPE' | translate"
                 name="rate" />
        </div>
        <div *ngIf="hasCRM">
          <label for="estimatedFees"
                 translate="TOOLBAR.FEES"></label>
          <input type="text"
                 disabled="disabled"
                 [value]="estimatedFees | currency: currencySymbol:'symbol-narrow':'1.2-2':currentLang"
                 name="estimatedFees" />
        </div>
        <div *ngIf="!hasCRM">
          <label for="laborBillingMethod"
                 translate="HEADER.LABOR_BILLING_METHOD"></label>
          <input type="text"
                 disabled="disabled"
                 [value]="currentEstimate?.laborBillingMethodCode"
                 name="laborBillingMethod" />
        </div>
      </div>
    </div>
  </form>
</mat-expansion-panel>
